import { render, staticRenderFns } from "./signaturePopLeader.vue?vue&type=template&id=78e3bc6a"
import script from "./signaturePopLeader.vue?vue&type=script&lang=js"
export * from "./signaturePopLeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e3bc6a')) {
      api.createRecord('78e3bc6a', component.options)
    } else {
      api.reload('78e3bc6a', component.options)
    }
    module.hot.accept("./signaturePopLeader.vue?vue&type=template&id=78e3bc6a", function () {
      api.rerender('78e3bc6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/signaturePopLeader.vue"
export default component.exports